import React from 'react';
import Icon from '@components/AppIcon';

const ServiceHero = () => {
  return (
    <section
      className="relative pt-28 pb-20 md:pt-32 md:pb-28 min-h-[480px] flex items-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`, // Use your local image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay for readability */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Headline */}
        <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-6 drop-shadow-lg">
          Our Services
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 leading-relaxed drop-shadow-md max-w-3xl mx-auto">
          Comprehensive eye care solutions for all ages, delivered by experienced professionals using advanced technology.
        </p>

        {/* Service Highlights */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/90">
          <div className="flex items-center gap-2 text-lg font-medium">
            <Icon name="Eye" size={22} className="text-[#eb2227]" />
            <span>Full Eye Exams</span>
          </div>
          <div className="flex items-center gap-2 text-lg font-medium">
            <Icon name="Activity" size={22} className="text-[#eb2227]" />
            <span>Advanced Diagnostics</span>
          </div>
          <div className="flex items-center gap-2 text-lg font-medium">
            <Icon name="Heart" size={22} className="text-[#eb2227]" />
            <span>Personalized Care</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
